// Generated by CoffeeScript 2.7.0
var DisabledText, ReleaseSetting, namecard_item;

import SearchMixin from 'trunks/vue/admin/components/search/mixin.js';

import OptionGroup from 'trunks/vue/share/components/option_group.js';

import selectOrganization from 'trunks/vue/admin/compositions/select_organization.js';

import {
  newAlertify
} from 'trunks/vue/admin/components/alert.js';

DisabledText = '必须选择接收组织后才能选择该项';

namecard_item = {
  name: 'namecard-item',
  props: {
    selected: {
      type: Boolean
    },
    item: {
      type: Object
    },
    selectedNamecard: {
      type: Object
    }
  },
  template: `<div class="list-item">
  <div class='item-wrapper justify-between'
      @click.stop='nameCardChange'>
    <div class='content node-name text-ellipsis'>
      <span>{{ item.name }}</span>
    </div>
    <div class="item-check" v-if="item == selectedNamecard">
      <i class="slp-check"></i>
    </div>
  </div>
</div>`,
  methods: {
    nameCardChange: function() {
      if (this.item === this.selectedNamecard) {
        return this.$emit('nameCardChange', null);
      } else {
        return this.$emit('nameCardChange', this.item);
      }
    }
  }
};

export default ReleaseSetting = {
  mixins: [SearchMixin],
  components: {
    'OptionGroup': OptionGroup,
    'select-organization': selectOrganization,
    'namecard-item': namecard_item
  },
  props: {
    initialReleaseStatus: {
      type: Object
    },
    releaseOptions: {
      type: Array,
      default: function() {
        return ['release_personal', 'release_organization'];
      }
    },
    userBoundary: {
      type: Object,
      default: null
    }
  },
  data: function() {
    return {
      formatedReleaseOptions: this._generateReleaseOptions(),
      disabledOption: this._initDisabledOption(),
      releaseOrganization: false,
      nameCards: [],
      selectedNamecard: null,
      selectedOrganization: null
    };
  },
  template: `<div class="release-setting">
  <div class="tab-section">
    <h4>发布名义:</h4>
    <div class="tab-section-content">
      <OptionGroup optionsClass="release-status-options"
               :initialValue="[releaseStatusOption]"
               :options="releaseStatusOptionsForSelect"
               :multiple="false"
               :userBoundary="userBoundary"
               :canCancelSingleSelect="false"
               @valueChange="onOptionValueChangeFunc"
               ref="optionRef" />
      <div class="organization-content" v-if="releaseOrganization">
        <div class="content-box">
          <div class="content-left-img">
            <img v-if="selectedNamecard?selectedNamecard.picture : ''" class="organization-image" :src="selectedNamecard?selectedNamecard.picture : ''" alt="">
            <i v-else class="slp-image"></i>
            <p class="title">(组织名义图片预览)</p>
          </div>
          <div class="content-right">
            <select-organization :userBoundary="userBoundary"
                                  @selectedNodeChange="selectedOrganizationChange"/>
            <div class="select-wrapper">
              <h4>组织名片:</h4>
              <Popover position="bottom"
                       :caret="false"
                       :loadContent="true"
                       :manualToggle="true"
                       :blockContent="true"
                       @triggerClicked="triggerClicked"
                       ref="popoverVm">
                <template slot='trigger'>
                  <div class="field-input-container">
                    <div class="field-input">
                      <div class="field-value">
                        <div class="selected-node" :class="selectedNamecard? '' : 'placeholder'">{{selectedNamecard?selectedNamecard.name : '请选择'}}</div>
                      </div>
                      <div class="select-caret">
                        <i class="slp-caret-down placeholder"></i>
                      </div>
                    </div>
                    <div class="error-message"></div>
                  </div>
                </template>
                <div slot='content' v-if="!nameCards.length">
                  <div class="list-item">没有可选的名片</div>
                </div>
                <div slot='content' v-else>
                  <namecard-item  v-for="item in nameCards"
                                  :key="item.id"
                                  :item="item"
                                  :class='{selected: item._selected}'
                                  :selectedNamecard='selectedNamecard'
                                  @nameCardChange="nameCardChange"/>
                </div>
              </Popover>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>`,
  created: function() {
    var init_release_status_option;
    init_release_status_option = _.find(this.formatedReleaseOptions, (option) => {
      return option.id === this.initialReleaseStatus;
    });
    this.releaseStatusOption = this.defaultEnableReleaseStatusOption || init_release_status_option;
    return this.setDisabledStatus();
  },
  watch: {
    userBoundary: function(ub) {
      this.disabledOption = this._initDisabledOption();
      this.releaseOrganization = false;
      this.releaseStatusOption = this.defaultEnableReleaseStatusOption;
      this.setDisabledStatus();
      return this.reset();
    }
  },
  computed: {
    releaseStatusOptionsForSelect: function() {
      return this.formatedReleaseOptions;
    },
    defaultEnableReleaseStatusOption: function() {
      return _.first(this.formatedReleaseOptions);
    },
    tip: function() {
      if (this.selectedOrganization) {
        if (!this.selectedNamecard) {
          return '请选择组织名片';
        }
      } else {
        return '请选择发布名义的组织';
      }
    }
  },
  methods: {
    getData: function() {
      if (this.releaseStatusOption.id === _.last(this.releaseOptions)) {
        if (this.tip) {
          newAlertify(`发布失败, ${this.tip}`, {
            type: 'error'
          });
          return;
        }
        return {
          // 当选择第二项并组织名义或组织名片为空时返回undefined
          organization_id: this.selectedOrganization.id,
          namecard_id: this.selectedNamecard.id
        };
      } else {
        return {};
      }
    },
    // 选择第一项返回空对象
    onOptionValueChangeFunc: function(options) {
      var option;
      option = _.first(options);
      if (option) {
        return this.changeReleaseStatusOption(option);
      }
    },
    reset: function() {
      this.selectedOrganization = null;
      this.selectedNamecard = null;
      return this.nameCards = [];
    },
    changeReleaseStatusOption: function(option) {
      this.releaseStatusOption = option;
      if (this.releaseStatusOption.id === _.last(this.releaseOptions)) {
        return this.releaseOrganization = true;
      } else {
        this.releaseOrganization = false;
        return this.reset();
      }
    },
    selectedOrganizationChange: function(node) {
      if (node) {
        this.selectedOrganization = node;
        Skylark.Libs.Ajax.get(`/admin/organizations/${node.id}/namecards.json`, {
          responseType: 'json',
          success: (nodes) => {
            return this.nameCards = nodes;
          }
        });
      } else {
        this.selectedOrganization = null;
        this.nameCards = [];
      }
      return this.selectedNamecard = null;
    },
    nameCardChange: function(item) {
      this.selectedNamecard = item || null;
      return this.$refs.popoverVm.close();
    },
    triggerClicked: function(event) {
      return this.$refs.popoverVm.open();
    },
    setDisabledStatus: function() {
      return _.each(this.formatedReleaseOptions, (option) => {
        if (option.id === this.disabledOption) {
          option._status = 'disabled';
          return option.label = `${option.value}(${DisabledText})`;
        } else {
          option._status = '';
          return option.label = `${option.value}`;
        }
      });
    },
    _initDisabledOption: function() {
      if (this.userBoundary.organization_ids.length === 0) {
        return _.last(this.releaseOptions);
      } else {
        return null;
      }
    },
    _generateReleaseOptions: function() {
      return _.map(this.releaseOptions, function(option_id) {
        return new Skylark.App.Model.FieldOption({
          id: option_id,
          value: Skylark.Helpers.translate("release.status." + option_id)
        });
      });
    }
  }
};
